import { render, staticRenderFns } from "./DatetimePickerDialogOrder.vue?vue&type=template&id=0b231c86&scoped=true"
import script from "./DatetimePickerDialogOrder.vue?vue&type=script&lang=ts"
export * from "./DatetimePickerDialogOrder.vue?vue&type=script&lang=ts"
import style0 from "./DatetimePickerDialogOrder.vue?vue&type=style&index=0&id=0b231c86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b231c86",
  null
  
)

export default component.exports